import Header from "@/components/Header";
import { useUser } from "@/hooks/useUser";
import { Navigate, Outlet } from "react-router-dom";

export default function VerifikatorSehatLayout() {
  const { user, isPending } = useUser();
  const userRoles = user?.jenis_user || [];
  const verifikator = userRoles.includes("verifikator_sehat") || userRoles.includes("verifikator_sehat_all");

  if (!isPending && !verifikator) return <Navigate to={"/"} />;

  return (
    <main className="flex">
      {/* <Sidebar navigationMenus={verifikatorSehatNavigations} /> */}
      <section className="flex-1 overflow-x-auto p-5 min-h-screen">
        <Header />
        <Outlet />
      </section>
    </main>
  );
}
